import { render, staticRenderFns } from "./SupplierMenu.vue?vue&type=template&id=2165b8ce"
import script from "./SupplierMenu.vue?vue&type=script&lang=js"
export * from "./SupplierMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports